import { render, staticRenderFns } from "./TrocarSenha.vue?vue&type=template&id=5f8c8828&scoped=true"
import script from "./TrocarSenha.vue?vue&type=script&lang=ts"
export * from "./TrocarSenha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c8828",
  null
  
)

export default component.exports